export default __webpack_public_path__ + "static/media/myAthina_Desktop.27f61434.svg";